import React, { useEffect, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { Package, ChatTeardrop, TrendUp, ArrowRight } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function AdminDashboard() {
  const [products, setProducts] = useState([]);
  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { include_unpublished: true } }).then((r) => setProducts(r.data));
    api.get("/admin/contact").then((r) => setSubmissions(r.data));
  }, []);

  const published = products.filter((p) => p.is_published).length;
  const unread = submissions.filter((s) => !s.read).length;

  const cards = [
    { label: "Total Products", value: products.length, sub: `${published} published`, icon: Package, color: "from-[#FF6B9E] to-[#F43F5E]" },
    { label: "Submissions", value: submissions.length, sub: `${unread} unread`, icon: ChatTeardrop, color: "from-[#A78BFA] to-[#38BDF8]" },
    { label: "Total Likes", value: products.reduce((a, p) => a + (p.likes || 0), 0), sub: "across catalog", icon: TrendUp, color: "from-[#34D399] to-[#38BDF8]" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter">Studio dashboard</h1>
      <p className="text-slate-600 mt-2">Run the Hangang Global story from one place.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
        {cards.map((c) => (
          <div key={c.label} className="brutal-card rounded-3xl p-6">
            <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${c.color} text-white flex items-center justify-center mb-4`}>
              <c.icon size={20} weight="bold" />
            </div>
            <div className="font-display text-4xl font-black">{c.value}</div>
            <div className="label-uppercase text-slate-500 mt-1">{c.label}</div>
            <div className="text-xs text-slate-600 mt-2">{c.sub}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-8">
        <Link to="/admin/products" data-testid="dashboard-link-products" className="brutal-card rounded-3xl p-6 flex items-center justify-between hover:translate-y-[-2px] transition">
          <div>
            <div className="label-uppercase text-[#FF6B9E]">Manage</div>
            <div className="font-display text-2xl font-black mt-1">Products & Drops</div>
            <div className="text-sm text-slate-600 mt-1">Upload, edit, publish.</div>
          </div>
          <ArrowRight size={28} weight="bold" />
        </Link>
        <Link to="/admin/submissions" data-testid="dashboard-link-submissions" className="brutal-card rounded-3xl p-6 flex items-center justify-between hover:translate-y-[-2px] transition">
          <div>
            <div className="label-uppercase text-[#A78BFA]">Inbox</div>
            <div className="font-display text-2xl font-black mt-1">Partnership inquiries</div>
            <div className="text-sm text-slate-600 mt-1">{unread} unread, {submissions.length} total.</div>
          </div>
          <ArrowRight size={28} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
